export default __webpack_public_path__ + "static/media/avatar_cow5.e18ee92e.mp3";